var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Box", [
    _vm.currentTabId
      ? _c(
          "div",
          { staticClass: "builder-container" },
          [
            _c("Progress-Nav", {
              attrs: { navItems: _vm.topMenuItems, active: _vm.currentTabId },
              on: {
                input: function($event) {
                  return _vm.navigateToTab($event)
                }
              }
            }),
            _vm._v(" "),
            _c("progress-bar"),
            _vm._v(" "),
            _c("router-view")
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }